import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader'

const AdminBooking = () => {
    const [booking, setBooking] = useState([]);

  // fetch contact form submission enquiry from backend
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await fetch('https://apis.anvifoundation.com/omanshi/get-trip-details');
        const data = await response.json();

        if (response.ok) {
          setBooking(data); // Store the fetched sites in state
        } else {
          console.error('Failed to fetch enquiries:', data);
        }
      } catch (error) {
        console.error('Error while fetching enquiries:', error);
      }
    };

    fetchEnquiry();
  }, []); // Empty dependency array means it runs once when the component mounts


  return (
    <>
      <SubHeader message="Bookings" />

      <section className='py-5 bg-light'>
        <div className='container text-center px-lg-5 px-3'>

          <p className='sec-subheading'>Trip Details Submissions</p>
          {/* <p className='sec-heading'>Enquiries Received</p> */}

          <div className='table-responsive mt-4'>
            <table className='table w-100'>

              <tr className='bg-white'>
                <th className='px-3 py-3'>S No</th>
                <th className='px-3 py-3'>Name</th>
                <th className='px-3 py-3'>Phone</th>
                <th className='px-3 py-3'>Email</th>
                <th className='px-3 py-3'>Starting</th>
                <th className='px-3 py-3'>Destination</th>
                <th className='px-3 py-3'>Vehicle Selected</th>
              </tr>

              {booking.length > 0 ? (
                booking.map((bookings, index) => (
                  <tr key={bookings.id}>
                    <td className='px-3 py-2'>{index + 1}</td>
                    <td className='px-3 py-2'>{bookings.name}</td>
                    <td className='px-3 py-2'>{bookings.phone}</td>
                    <td className='px-3 py-2'>{bookings.email}</td>
                    <td className='px-3 py-2'>{bookings.starting_point}</td>
                    <td className='px-3 py-2'>{bookings.destination_point}</td>
                    <td className='px-3 py-2'>{bookings.vehicle_name}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="7" className='px-3 py-2'>No Trip Details Submitted</td></tr>
              )}

            </table>
          </div>


        </div>
      </section>
    </>
  )
}

export default AdminBooking
